<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M14.5407 0.199992C14.4209 -0.075389 14.0273 -0.0632524 13.9417 0.217085L13.1202 2.59671C13.0859 2.66149 13.0859 2.73329 13.103 2.79824L14.6092 7.54347C14.6434 7.67681 14.7804 7.76911 14.9173 7.76911L19.8808 7.74005C19.9492 7.74005 20.0177 7.71937 20.069 7.68022L22.0373 6.25272C22.294 6.07837 22.1913 5.70077 21.8833 5.67171L16.7829 5.1777C16.6631 5.16744 16.5605 5.09052 16.509 4.97941L14.5407 0.199992ZM10.0748 0.259825L10.7594 2.59825C10.7765 2.6615 10.7594 2.72645 10.7423 2.78799L9.18497 7.54502C9.15057 7.67869 9.03076 7.76912 8.89384 7.76912H4.01593C3.94747 7.76912 3.87901 7.74689 3.82766 7.70587L1.82515 6.24777C1.58554 6.07341 1.70534 5.69564 1.99648 5.66812L7.04537 5.17599C7.16517 5.16556 7.26787 5.09394 7.31939 4.98796L9.47576 0.21709C9.59557 -0.05641 9.98923 -0.0273506 10.0748 0.259825ZM23.1661 9.80518C23.4741 9.80348 23.6111 10.1676 23.3886 10.3657L19.5718 13.8256C19.4862 13.9009 19.4522 14.0137 19.4691 14.1248L20.4276 19.1316C20.4791 19.4204 20.1366 19.6254 19.9141 19.4478L17.9972 18.0017C17.9287 17.9587 17.8945 17.9008 17.8774 17.8324L16.491 13.0376C16.4568 12.9077 16.5081 12.7657 16.6108 12.6872L20.5474 9.88383C20.5987 9.84451 20.6674 9.824 20.7358 9.824L23.1661 9.80518ZM11.7168 16.193C11.8366 16.1091 11.9906 16.1091 12.1104 16.193L16.0127 19.0732C16.0812 19.1161 16.1156 19.1757 16.1326 19.2426L16.8514 21.6663C16.937 21.9519 16.6118 22.1878 16.3551 22.0289L12.0591 19.2992C11.9564 19.2323 11.8195 19.2323 11.7168 19.3007L7.45502 22.0271C7.19829 22.1878 6.89021 21.9536 6.95867 21.6682L7.64346 19.2802C7.6604 19.2116 7.71175 19.152 7.7631 19.1092L11.7168 16.193ZM3.29675 9.81662L0.832127 9.81184C0.524049 9.81184 0.387297 10.1775 0.609626 10.3741L4.37503 13.7244C4.4606 13.8031 4.49501 13.921 4.47772 14.0355L3.33098 19.0953C3.27981 19.3857 3.60483 19.6014 3.84445 19.4235L5.77867 17.9842C5.84713 17.9432 5.88119 17.8868 5.8983 17.8218L7.40446 13.0424C7.45581 12.9108 7.40446 12.7672 7.28465 12.6868L3.48502 9.88004C3.43368 9.83902 3.36521 9.81662 3.29675 9.81662Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgGBANewsFeed',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>